import { TModoGestaoAtendimento } from "../../../../Interfaces/AssistenciaTecnica/Atendimento/AtendimentoInterfaces";
import ModalComponent from "../../../../Components/Modais";
import {
    ExportarExcelAssistenciaTecnicaController,
    ListarAtendimentosAssisTecTransferirController,
} from "../../../../Controllers/AssistenciaTecnica/GestaoDeAtendimento/GestaoDeAtendimentoController";
import ExportExcel from "../../../../Components/StickyToolbar/ExportExcel";
import TransferirTodosAtendimento from "../../../../Components/CardsPages/Atendimento/TransferirTodosAtendimentos";
import FiltroAtendimento from "../FiltroAtendimento";
import { useAtendimentosAssistencia } from "./useAtendimentosAssistencia";
import TableAtendimentosAssistencia from "./TableAtendimentosAssistencia";
import { ACESSOS } from "../../../../Routes/Acessos";
interface IAtendimentosAssistenciaProps {
    atendimento: TModoGestaoAtendimento;
}

export interface IFormData {
    ID_CASO?: number;
    ID_CONTA?: number;
    DT_INICIO_IN?: string;
    DT_INICIO_FN?: string;
    DT_FIM_IN?: string;
    DT_FIM_FN?: string;
    DS_STATUS_SOLICITACAO?: string;
    DS_CONTA?: string;
    DS_CONTATO?: string;
    ID_USUARIO_RESPONSAVEL?: number;
    ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASOS?: number;
    ID_EMPREENDIMENTO?: Array<{
        label: string;
        value: number;
    }>;
    PESQUISA?: string;
    ID_TIPO_CANAL_ATENDIMENTO?: number;
}

export default function GestaoAtendimentoAssisTecPage(
    props: IAtendimentosAssistenciaProps
) {
    const {
        show,
        setShow,
        modal,
        setModal,
        lstAtendimentos,
        handleSearch,
        setPesquisaText,
        pesquisaText,
        loading,
        totalPaginas,
        setFilter,
        setPage,
        FILTRO_ATENDIMENTOS,
        filter,
        handleDateChange,
        filtroInicial,
        execute,
    } = useAtendimentosAssistencia(props.atendimento);

    return (
        <div style={{ minHeight: "350px" }} className="card card-custom">
            <div className="card-body mt-n5 table-responsive">
                <TableAtendimentosAssistencia
                    lstAtendimentos={lstAtendimentos}
                    loading={loading}
                    totalPaginas={totalPaginas}
                    handleSearch={handleSearch}
                    setPesquisaText={setPesquisaText}
                    setFilter={setFilter}
                    setPage={setPage}
                    setModal={setModal}
                    setShow={setShow}
                    filter={filter}
                    execute={execute}
                    pesquisaText={pesquisaText}
                />
            </div>
            <FiltroAtendimento
                FILTRO_ATENDIMENTOS={FILTRO_ATENDIMENTOS}
                filter={filter}
                handleSubmit={(formData) => {
                    handleDateChange(formData);
                }}
                filtroInicial={filtroInicial}
                setFilter={setFilter}
                setPage={setPage}
                // setNaoContem={setNaoContem}
            />

            <ModalComponent
                show={show}
                setShow={setShow}
                ModalComponent={modal}
            />

            <TransferirTodosAtendimento
                ID_TIPO_CASO={ACESSOS.ASSISTENCIA.ID_MODULO}
                filter={filter}
                setShow={setShow}
                update={() => {
                    execute(filter, 1, props.atendimento);
                }}
                controller={() =>
                    ListarAtendimentosAssisTecTransferirController(
                        filter ?? {},
                        0,
                        props.atendimento
                    )
                }
            />

            <ExportExcel
                baixarExcelController={async () =>
                    ExportarExcelAssistenciaTecnicaController(
                        props.atendimento,
                        filter ?? {}
                    )
                }
                nomeArquivo={"Atendimentos_Assistência_Técnica"}
            />
        </div>
    );
}
